export default "__VITE_ASSET__Vcm0hRt4__"